import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styles from './PublishProcessOverlay.scss';

const PublishProcessOverlay = (props) => (
  <Modal
    {...props}
    className={styles.processModal}
    overlayClassName={styles.processOverlay}
    shouldCloseOnOverlayClick={false}
    shouldCloseOnEsc={false}
    contentLabel="OnMap Publish Process Overlay"
  >
    <div className={styles.content}>
      <i className="icon icon-om-spinner om-pulse" />
      <div className={styles.title}>
        {props.translate('processOverlayTitle')}
      </div>
      <div className={styles.subtitle}>
        {props.translate('processOverlaySubtitle')}
      </div>
    </div>
  </Modal>
);

PublishProcessOverlay.propTypes = {
  translate: PropTypes.func
};

export default PublishProcessOverlay;
